// extracted by mini-css-extract-plugin
export default {"trustpilot":"TrustPilotReviews-styles__trustpilot-TODG","landingPageVariant":"TrustPilotReviews-styles__landingPageVariant-q62t"};